<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return { kioskInfo: {} };
  },
  name: "RefreshFaceLibrary",
  props: ["data"],
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
  },
  methods: {
    ...mapActions("daemon", ["refreshFaceLibrary"]),
    onSubmit() {
      this.refreshFaceLibrary(this.kioskInfo);
      this.$bvModal.hide("refreshFaceLibrary_" + this.data.id);
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("refreshFaceLibrary_" + this.data.id);
    },
  },
  beforeMount() {
    this.kioskInfo = {
      mac_address: this.data.mac_address,
      kiosk_name: this.data.name,
    };
    console.log(this.kioskInfo);
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <h4 class="allareakiosk-header">Refresh Face Library</h4>
    <h3 class="confirmation-msg">
      Are you sure you want to "Refresh" the face library on the kiosk "{{
        data.name
      }}"?
    </h3>
    <div class="actionsline-inside"></div>
    <div class="actions-btns">
      <button
        class="submit-btn btn btn-primary add-submit"
        size="md"
        @click="onSubmit"
      >
        Refresh
      </button>
      <button
        class="btn btn-outline-danger cancel-reject"
        @click="$bvModal.hide('refreshFaceLibrary_' + data.id)"
      >
        Cancel
      </button>
    </div>
  </div>
</template>
<style lang="scss">
div[id*="refreshFaceLibrary_"] {
  div[class*="modal-content"] {
    position: absolute;
    float: inline-start;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 45%);
    div[class*="modal-body"] {
      padding-top: 41px;
      padding-inline-end: 0px;
      padding-bottom: 0px;
      padding-inline-start: 46px;
      h4.allareakiosk-header {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        color: #000000;
        margin-top: 0px;
        margin-inline-end: auto;
        margin-bottom: 51px;
        margin-inline-start: 0px;
        text-align: center;
      }
      .confirmation-msg {
        font-weight: 400;
        font-size: 20px;
        line-height: 33px;
        text-align: center;
        color: #787878;
        margin-inline-end: 51px;
        margin-inline-start: 5px;
      }

      .actionsline-inside {
        background: #707070;
        height: 1px;
        opacity: 0.15;
        margin-top: 43px;
        margin-bottom: 20px;
        margin-inline-end: 36px !important;
      }
      .actions-btns {
        margin-inline-end: 36px;
        // background: red;
        margin-bottom: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        .submit-btn {
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 19px !important;
          text-align: center;
          color: #ffffff !important;
          margin-inline-end: 15px !important;
          width: 111px !important;
          height: 33px !important;
          border-radius: 16px !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cancel-reject {
          margin-inline-start: 15px;
          width: 111px !important;
          height: 33px !important;
          border-radius: 16px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 19px !important;
          text-align: center;
        }
      }
    }
  }
}
</style>
